import { BottomTabNavigationProp } from '@react-navigation/bottom-tabs'
import {
  CompositeNavigationProp,
  ParamListBase,
} from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { Button, Colors, Icon, Theme } from '@rneui/themed'
import { ConversationTabParamList } from 'chat/conversations/types'
import { FileFoldersBottomTabParamList } from 'file_folder_repository/chat_group_folders/stack/types'
import { HomeStackParamList } from 'home/stack/types'
import React from 'react'
import { Platform, View } from 'react-native'

type Position = 'left' | 'right'

export type IconButton = {
  name: string
  type?: string
  onPress: () => void
  disabled?: boolean
  loading?: boolean
}

export function showHeaderButtonList<
  ParamList extends ParamListBase,
  RouteName extends keyof ParamList
>({
  navigation,
  theme,
  buttons,
  position = 'right',
}: {
  navigation:
    | StackNavigationProp<ParamList, RouteName>
    | CompositeNavigationProp<
        BottomTabNavigationProp<ConversationTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >
    | CompositeNavigationProp<
        BottomTabNavigationProp<FileFoldersBottomTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >
  theme: {
    colors: Colors
  } & Theme
  buttons: IconButton[]
  position?: Position
}) {
  if (position === 'left' && Platform.OS !== 'ios') {
    return
  }

  const header = position === 'left' ? 'headerLeft' : 'headerRight'

  navigation.setOptions({
    ...(position === 'right' && {
      headerRightContainerStyle:
        buttons.length > 0
          ? { minWidth: Math.max(52, buttons.length * 34), flexShrink: 0 }
          : undefined,
    }),
    [header]: () => (
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {buttons.map((button, index) => (
          <View key={index} style={{ marginRight: 10 }}>
            {button.type ? (
              <Icon
                name={button.name}
                type={button.type}
                color={theme.colors?.primary}
                onPress={button.onPress}
                disabled={button.disabled}
              />
            ) : (
              <Button
                title={button.name}
                buttonStyle={{
                  backgroundColor: 'transparent',
                  padding: 0,
                }}
                disabledStyle={{ backgroundColor: 'transparent' }}
                titleStyle={{
                  color: theme.colors?.primary,
                  fontSize: 17,
                  letterSpacing: 0.35,
                  fontFamily: 'System',
                }}
                titleProps={{ allowFontScaling: false }}
                onPress={button.onPress}
                disabled={button.disabled}
                loading={button.loading}
                loadingProps={{ size: 'small', color: theme.colors.primary }}
                loadingStyle={{ paddingRight: 10 }}
              />
            )}
          </View>
        ))}
      </View>
    ),
  })
}
